const data = [
  {
    id: 1,
    name: 'about',
    to: '#about',
  },
  { id: 2, name: 'experience', to: '#experience' },
  { id: 3, name: 'works', to: '/works' },
  { id: 4, name: 'contact', to: '#contact' },
];

export default data;
